import { Popover, IconButton } from '@chakra-ui/react';
import { Portal } from '@halo/ui-react';
import type { PropsWithChildren } from 'react';
import PreviewEyeIcon from '@/assets/images/common/svg/eye.svg?react';

const ButtonTrigger = (props: PropsWithChildren) => {
  const { children } = props;
  const { t } = useTranslation();
  return (
    <Popover.Root
      positioning={{ placement: 'right', strategy: 'fixed', hideWhenDetached: true }}
      lazyMount
      unmountOnExit
    >
      <Popover.Trigger asChild>
        <IconButton variant="outline" size="sm" color="fg" borderRadius="lg" px="4">
          <PreviewEyeIcon />
          {t('userOnboarding.preview')}
        </IconButton>
      </Popover.Trigger>
      <Portal>
        <Popover.Positioner>
          <Popover.Content w="max-content" maxW="250px">
            <Popover.Arrow>
              <Popover.ArrowTip />
            </Popover.Arrow>
            {children}
          </Popover.Content>
        </Popover.Positioner>
      </Portal>
    </Popover.Root>
  );
};
export { ButtonTrigger };
